module.exports = __webpack_public_path__ + "static/media/cloudsuite_app.d9817ff1.svg";